export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingService) {
        function handleClick() {
            const path = location.pathname.substring(
                0,
                location.pathname.lastIndexOf('/') + 1
            );
            const url = `${path}gallery-lightbox.html`;
            trackingService.trackCurrentPage({
                context: {
                    'tracking-location': `${url}${location.search}`,
                },
            });
        }
        ele.addEventListener('click', handleClick);
    },
};



// WEBPACK FOOTER //
// ./controllers/trackGalleryLightbox.js